// extracted by mini-css-extract-plugin
export default {"small":"s9xSHE1gv21XgOy6julN","medium":"_6uWr_X2hOeA8BjuBXTV"};